import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import ai from '../assets/ai.png';
import google from '../assets/google.png';
import blender from '../assets/Blender.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import seo from '../assets/seo_google.png';
import adobe from '../assets/adobe.png';
import circle from '../assets/circle.svg';
import aldolo from '../assets/aldolo.png';
import java from '../assets/java.png';
import firebase from '../assets/firebase.png';
import web from '../assets/web.png';



export default {
  api,
  cpp,
  firebase,
  flutter,
  git,
  ai,
  web,
  google,
  blender,
  node,
  python,
  java,
  react,
  seo,
  adobe,
  circle,
  aldolo,
};
